module.exports = __webpack_public_path__ + "img/image002.fcf24e4b.jpg";